import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ComponentsModule } from '../shared/components/components.module';
import { ProperWordingRoutingModule } from './proper-wording-routing.module';

import { ProperWordingComponent } from './proper-wording.component';


@NgModule({
  declarations: [
    ProperWordingComponent
  ],
  imports: [
    CommonModule,
    ComponentsModule,
    ProperWordingRoutingModule,
  ]
})
export class ProperWordingModule { }
